export default "__VITE_ASSET__zRFICLK___"